<template>
    <div class="body-panel">
        <div class="gate-keeper-header-panel">
            <div class="panel-info">

            </div>
            <div class="panel-options">
                <b-button @click="showNewTicketSellerUser" type="is-primary">ADD NEW SELLER</b-button>
            </div>
        </div>
        <div class="gate-keeper-body-panel">
            <div v-if="!loading_users && users.length > 0" class="table-widget">
                <table>
                    <tr>
                        <th>Profile</th>
                        <th>Assigned Event</th>
                        <th>Sold Ticket</th>
                        <th>Total Amount</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                    <tr v-for="(item, index) in users" :key="index">
                        <td>
                            <widgetProfile :title="`${item.first_name} ${item.last_name}`" :subtitle="item.phone"
                                :file_name="item.profile_image"
                                :path="$store.state.ASSETS_BASE_URL + '/assets/uploaded/'">
                            </widgetProfile>
                        </td>
                        <td>{{ `${item.eventTitle}` }}</td>
                        <td>{{ `${item.soldTickets ? item.soldTickets : 0}` }}</td>
                        <td>{{ `RWF ${item.totalAmount ? item.totalAmount : 0}` }}</td>
                        <td>
                            <b-tag v-if="item.status == 'inactive'" type="is-warning">Inactive</b-tag>
                            <b-tag v-if="item.status == 'active'" type="is-success">Active</b-tag>
                        </td>
                        <td>
                            <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                                <template #trigger>
                                    <b-icon icon="dots-vertical"></b-icon>
                                </template>
                                <b-dropdown-item @click="updateUser(item)" aria-role="listitem">Update</b-dropdown-item>
                                <b-dropdown-item @click="deleteUser(item.id, index)"
                                    aria-role="listitem">Delete</b-dropdown-item>
                            </b-dropdown>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <addNewTicketSellerUser v-if="showNewTicketSellerUserModal" :value="selected_user" @saved="getAllTicketSeller()"
            @close="showNewTicketSellerUserModal = false">
        </addNewTicketSellerUser>
    </div>
</template>

<script>
import addNewTicketSellerUser from "./modals/addNewTicketSellerUser.vue"
export default {
    components: {
        addNewTicketSellerUser
    },
    data: () => ({
        users: [],
        loading_users: false,
        showNewTicketSellerUserModal: false,
        selected_user: null,
    }),
    watch: {},
    mounted() {
        let vm = this;
        vm.getAllTicketSeller();
    },
    methods: {
        getAllTicketSeller() {
            let vm = this;
            vm.showNewTicketSellerUserModal = false;
            vm.loading_users = true;
            vm.$store
                .dispatch("ADMIN_TICKET_SELLER_GET_ALL")
                .then((response) => {
                    vm.loading_users = false;
                    vm.users = response.data.return;
                })
                .catch(({ response }) => {
                    vm.loading_users = false;
                });
        },
        showNewTicketSellerUser() {
            let vm = this;
            vm.selected_user = null;
            vm.showNewTicketSellerUserModal = true
        },
        updateUser(item) {
            let vm = this;
            vm.selected_user = item;
            vm.showNewTicketSellerUserModal = true;
        },
        deleteUser(id, index) {
            let vm = this;
            vm.$buefy.dialog.confirm({
                title: 'Deleting account',
                message: 'Are you sure you want to <b>delete</b> this account? This action cannot be undone.',
                confirmText: 'Delete Account',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    vm.$store
                        .dispatch("ADMIN_TICKET_SELLER_DELETE", { id })
                        .then((response) => {
                            vm.users.splice(index, 1);
                            vm.$notify({
                                group: "status",
                                type: "success",
                                title: "Important message",
                                text: response.data.message,
                            });
                        })
                        .catch(({ response }) => {
                            vm.loading_users = false;
                        });
                }
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.body-panel {
    height: calc(100% - 55px);


    .gate-keeper-header-panel {
        height: 70px;
        border-top: 1px solid #ddd;
        display: flex;
        align-items: center;
        padding: 0px 5px;
        border-bottom: 1px solid #ddd;
        justify-content: space-between;
    }

    .gate-keeper-body-panel {
        display: flex;
        flex-direction: column;
        height: calc(100% - 70px);
        padding: 20px;
        overflow-y: auto;
    }
}
</style>